import React from 'react'
import Header from '../../Components/Header'
import CardsProductionCapabilities from '../../Components/cardsProductionCapabilites'
import "./ProductionPage.css"

const ProductionPage = () => {
    return (
        <div >
            <Header />
                <CardsProductionCapabilities />
        </div>
    )
}

export default ProductionPage